import { twMerge } from 'tailwind-merge';

type SkeletonProps = {
  className?: string;
  isLoading?: boolean;
};

export function Skeleton(props: SkeletonProps) {
  const { className, isLoading = true } = props;
  const classNames = twMerge([isLoading ? 'animate-skeleton' : '', className]);

  return <span className={classNames} />;
}
